export const DEFAULT_USER_AUTH = {
  dadosUsuario: {},
  token: "",
  usuarioAutenticado: false,
  acao: ""
};
